import { z } from 'zod/v4';

export const NotificationSenderTypeDTO = z.enum([
  'EMAIL',
  'TELEGRAM',
  'WEBHOOK',
]);
export type NotificationSenderType = z.infer<typeof NotificationSenderTypeDTO>;